export function History() {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-4">Histórico de Indicações</h1>
      <p className="text-muted-foreground mb-8">Confira o status das suas indicações enviadas.</p>
      <div className="overflow-x-auto border rounded-xl shadow-sm">
        <table className="w-full text-left">
          <thead className="bg-muted/50 border-b">
            <tr>
              <th className="p-4 font-semibold">Candidato</th>
              <th className="p-4 font-semibold">Data</th>
              <th className="p-4 font-semibold">Status</th>
              <th className="p-4 font-semibold">Bônus</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            <tr>
              <td className="p-4">João Silva</td>
              <td className="p-4">12/04/2026</td>
              <td className="p-4 text-green-600 font-medium">Contratado</td>
              <td className="p-4">R$ 500,00</td>
            </tr>
            <tr>
              <td className="p-4">Maria Oliveira</td>
              <td className="p-4">10/04/2026</td>
              <td className="p-4 text-blue-600 font-medium">Entrevista</td>
              <td className="p-4">-</td>
            </tr>
            <tr>
              <td className="p-4">Carlos Santos</td>
              <td className="p-4">08/04/2026</td>
              <td className="p-4 text-orange-600 font-medium">Em análise</td>
              <td className="p-4">-</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
